/* eslint-disable max-len */
export default {
    confirming: {
        confirmedOrder: 'Not all positions are agreed',
        totalSum: 'The amount of collected goods is zero',
        canBeAgreed: 'The order can be agreed upon',
        callFailed: 'You failed to reach the buyer 3 times. Please form an order with the items assembled',
    },

    confirmingDelivery: {
        confirmedOrder: 'Not all positions are agreed',
        totalSum: 'The amount of collected goods is zero',
        minSum: 'Order for less than {minSum} rubles cannot be agreed upon',
        completePackage: 'Packing container is not specified',
        canBeAgreed: 'The order can be agreed upon',
    },

    formationDelivery: {
        allProductsOutOfStock: `To cancel your order, click “Generate” (all items out of stock)`,
        emptyProducts: 'It is necessary to collect at least one product or cancel the order',
        noCollected: 'It is impossible to collect an order until the number of ordered and the number of collected goods are equal, or until the reason for changing the unassembled item is indicated',
        completePackage: 'Packing container is not specified',
        ready: 'The order is ready for assembly',
        update: 'Updated product information',
        tare: 'It is necessary to specify the weight for each packing container!',
        tareWeight: 'The total weight of all goods must not exceed {weight} kg',
        tareWeightSingle: 'The box is overweight. Delete the current box or transfer part of the positions to another box',
        disabledDelivery: 'Error creating an order in the courier service! Contact CRM technical support to solve this problem!',
    },

    formatting: {
        noCollected: 'It is impossible to collect an order until the number of ordered and the number of collected goods are equal, or until the reason for changing the unassembled item is indicated',
        noCollectedWithoutPacket: 'The order cannot be assembled until the number of ordered items and the number of assembled items are equal, or until the reason for changing the unassembled item is specified, or until at least 1 package is added.',
        ready: 'The order is ready for assembly',
        update: 'Updated product information',
    },
};